import React from 'react';
import type { ComponentType, SVGProps } from 'react';

import { View } from '@actual-app/components/view';

import { useIsNocturneTheme } from '#style/theme';

import { SecondaryItem } from './SecondaryItem';

type SecondaryButtonItems = {
  title: string;
  Icon:
    | ComponentType<SVGProps<SVGElement>>
    | ComponentType<SVGProps<SVGSVGElement>>;
  onClick: () => void;
};

type SecondaryButtonsProps = {
  buttons: Array<SecondaryButtonItems>;
};

export function SecondaryButtons({ buttons }: SecondaryButtonsProps) {
  const isNocturne = useIsNocturneTheme();

  return (
    <View
      style={{
        flexShrink: 0,
        padding: isNocturne ? '8.4px 0 16.8px' : '5px 0',
      }}
    >
      {buttons.map(item => (
        <SecondaryItem
          key={item.title}
          title={item.title}
          Icon={item.Icon}
          onClick={item.onClick}
          outlined={isNocturne}
        />
      ))}
    </View>
  );
}
